import { Component, inject } from '@angular/core';
import { KeycloakProfile } from 'keycloak-js';
import { ReleaseService } from './services/release.service';
import { Observable, tap } from 'rxjs';
import { ReleaseProduct } from './types';
import { ReleaseComponent } from './pages/release/release.component';
import { UserService } from './services/user.service';
import { RouteInitService } from './services/route-init.service';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { RouterLink, RouterOutlet } from '@angular/router';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { NzDropdownModule } from 'ng-zorro-antd/dropdown';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { AsyncPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import Keycloak from 'keycloak-js';

type RouteType = {
  path: string;
  title: string;
  description: string;
  roles: string[];
};

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    NzLayoutModule,
    NzMenuModule,
    NzIconModule,
    NzTooltipModule,
    NzSwitchModule,
    NzListModule,
    NzAvatarModule,
    NzDropdownModule,
    NzGridModule,
    NzSpaceModule,
    NzDividerModule,
    RouterLink,
    RouterOutlet,
    AsyncPipe,
    FormsModule,
    NzPopoverModule,
    NzTagModule,
    NzButtonModule,
  ],
})
export class AppComponent {
  private keycloak = inject(Keycloak);
  private releaseService = inject(ReleaseService);
  private userService = inject(UserService);
  private routeInitService = inject(RouteInitService);

  userProfile: KeycloakProfile | null = null;
  isCollapsed = false;
  isVisible = false;
  routes: RouteType[] = [];
  customerName = '';
  isSendEmailNotifications = true;

  userInfo$?: Observable<any>;
  action$?: Observable<any>;
  products$?: Observable<ReleaseProduct[]>;

  get userFullName(): string | undefined {
    return this.isCollapsed
      ? `${this.userProfile?.firstName} ${this.userProfile?.lastName}`
      : undefined;
  }

  ngOnInit(): void {
    if (this.routeInitService.shouldShowLoginModal) {
      return;
    }

    if (this.keycloak.authenticated) {
      this.products$ = this.loadRoutes();
      this.userInfo$ = this.userService.userInfo().pipe(
        tap(({ sendEmailNotification }) => {
          this.isSendEmailNotifications = sendEmailNotification;
        }),
      );

      this.keycloak.loadUserProfile().then((data) => {
        this.userProfile = data;
        this.isVisible = true;
      });

      this.customerName = this.keycloak.idTokenParsed?.['customer_name'];
    }
  }

  onCollapseEvent(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  onLogoutUserEvent(): void {
    this.keycloak.logout({ redirectUri: window.location.origin });
  }

  changeSendEmailNotification(data: boolean): void {
    this.isSendEmailNotifications = data;

    this.action$ = this.userService.updateUserInfo(data);
  }

  private loadRoutes(): Observable<ReleaseProduct[]> {
    return this.releaseService.products().pipe(
      tap((products) => {
        if (products.length > 0) {
          this.routes = products.map(
            (product) =>
              ({
                path: `product/${product.id}`,
                title: product.name,
                description: '',
                roles: [],
              }) as RouteType,
          );
        } else {
          this.routes = [
            {
              path: `releases`,
              title: 'BFS Terminal',
              description: '',
              roles: [],
              component: ReleaseComponent,
            } as RouteType,
          ];
        }

        this.routes.push({
          path: `file-sharing`,
          title: 'Файлообменник',
          description: '',
          roles: [],
        } as RouteType);
      }),
    );
  }
}
